import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { navigateToHomeSection } from '../utils/navigation';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    navigateToHomeSection(sectionId);
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { label: 'Services', id: 'services' },
    { label: 'Projects', id: 'projects' },
    { label: 'About', id: 'about' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <nav className="fixed top-0 w-full z-50 h-16 border-b border-white/10 backdrop-blur-md bg-black/40">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Left: Brand */}
        <button
          onClick={() => scrollToSection('hero')}
          className="flex items-center gap-3 text-left"
          aria-label="Go to home section"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 ring-1 ring-white/20 backdrop-blur-sm shadow-[0_0_20px_rgba(59,130,246,0.15)]">
            <img
              src="https://customer-assets.emergentagent.com/job_automation-nexus-6/artifacts/8a55j6ou_image.png"
              alt="Smart Automation Logo"
              className="h-7 w-7 object-contain"
            />
          </span>
          <div className="block max-w-[12rem] sm:max-w-none">
            <p className="text-white text-xs sm:text-sm md:text-base font-semibold leading-tight">
              {companyInfo.name}
            </p>
            <p className="text-white/65 text-[11px] sm:text-xs leading-tight">
              Ahmedabad, Anand, Baroda
            </p>
          </div>
        </button>

        {/* Right: Desktop Navigation + CTA */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="text-gray-300 hover:text-blue-400 transition-colors duration-200"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-full transition-all duration-300"
          >
            Get Solution
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/90 backdrop-blur-md border-t border-white/10">
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="block w-full text-left text-gray-300 hover:text-blue-400 transition-colors duration-200 py-2"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-full transition-all duration-300"
            >
              Get Solution
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
